/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: any
}

const SuitcaseOutline = createIcon({
  displayName: 'SuitcaseOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M17 21h-10l-1.74846e-07-3.55271e-15c-2.20914-9.65645e-08-4-1.79086-4-4 0 0 0 0 0 0v-8l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h14l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v8l3.55271e-15 8.74228e-08c0 2.20914-1.79086 4-4 4 -5.41844e-08 0-3.32383e-08 0-8.74228e-08 0Z" />
        <path d="M8 7v-2l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h4l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v2" />
        <rect width="4" height="3" x="10" y="11" rx=".27614" ry="0" />
        <path d="M14 12.5h3.5l-1.5299e-07-3.55271e-15c1.933 8.4494e-08 3.5-1.567 3.5-3.5v0" />
        <path d="M10 12.5h-3.5l-1.5299e-07-3.55271e-15c-1.933-8.4494e-08-3.5-1.567-3.5-3.5 0 0 0-1.77636e-15 0-1.77636e-15h-3.55271e-15" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24Z" />
    </>
  ),
})

const SuitcaseTwoTone = createIcon({
  displayName: 'SuitcaseTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="twoToneStrokeColor"
          d="M17 21h-10l-1.74846e-07-3.55271e-15c-2.20914-9.65645e-08-4-1.79086-4-4 0 0 0 0 0 0v-8l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h14l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v8l3.55271e-15 8.74228e-08c0 2.20914-1.79086 4-4 4 -5.41844e-08 0-3.32383e-08 0-8.74228e-08 0Z"
        />
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          d="M8 7v-2l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h4l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v2"
        />

        <Box as="path" stroke="twoToneStrokeColor" d="M14 12.5h3.5l-1.5299e-07-3.55271e-15c1.933 8.4494e-08 3.5-1.567 3.5-3.5v0" />
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          d="M10 12.5h-3.5l-1.5299e-07-3.55271e-15c-1.933-8.4494e-08-3.5-1.567-3.5-3.5 0 0 0-1.77636e-15 0-1.77636e-15h-3.55271e-15"
        />
        <Box as="rect" width="1" stroke="twoToneStrokeColor" fill="twoToneLightColor" height="1" x="10" y="11" rx=".27614" ry="0" />
      </g>
    </>
  ),
})

const Suitcase: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={SuitcaseTwoTone} {...props} />
    default:
      return <CustomIcon as={SuitcaseOutline} {...props} />
  }
}

export default memo(Suitcase)
